import { Field } from "../fields/field.model";
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable} from "rxjs";

export interface ParsedImportFile {
    filename: string,
    fields?: Field[],
    errorMessage?: string
}

@Injectable()
export class ImportBase {

    loadFields(files: File[]): Observable<ParsedImportFile[]>  {
        console.log("importBase returns empty list.")
        return new Observable<ParsedImportFile[]>();
    }

    protected isZipFile(file: File): boolean {
        return [
        'application/x-zip-compressed',
        'application/x-zip',
        'application/zip',
        'application/x-compressed',
        'application/x-compress',
        'application/octet-stream',
        ].includes(file.type);
    }
}

export function formatImportError(error: unknown): string {
    console.log("formatImportError:",error);
    if (error instanceof HttpErrorResponse) {
        const title = error.error.title?.trim();
        const detail = error.error.detail?.trim();

        if (title && detail) {
            return `${title}: ${detail}`;
        }
        if (title) {
            return title;
        }
        if (detail) {
            return detail;
        }
    }

    if (typeof error === 'string') {
        return error;
    }

    if (error instanceof Error) {
        return error.message;
    }

    if (error && typeof error === 'object' && 'message' in error) {
        const message = (error as { message?: unknown }).message;
        if (typeof message === 'string') {
            return message;
        }
    }

    return 'Unknown error';
}

